export default function TranslateView() {
  return (
    <div className="flex justify-center items-center bg-gray-200 h-full">
      <ul class="list-disc">
        <li>
          Now this is a story all about how, my life got flipped-turned upside
          down
        </li>
      </ul>
    </div>
  );
}
